import type { QueryClient } from '@tanstack/react-query';

/**
 * 考勤数据变了之后要失效的查询（CR-052）：复核、补录、标记已处理、撤销都走这里。
 *
 * 一个动作会同时动到：某人的明细、按人汇总、待复核 / 异常两个页签、工地概览的「待处理」、App 待办。
 * 收在一处 —— 分在四个地方各写一遍，总有一处漏掉一个，页签上的数字就对不上了。
 */
const ATTENDANCE_QUERY_KEYS = [
  'punches',
  'attendance-summary',
  'attendance-exceptions',
  'overview',
  'review-punches',
  'review-anomalies',
] as const;

export function invalidateAttendance(queryClient: QueryClient): void {
  for (const key of ATTENDANCE_QUERY_KEYS) {
    void queryClient.invalidateQueries({ queryKey: [key] });
  }
}
